module.exports = __webpack_public_path__ + "static/headerIcon-82ad31ad32f62b82ae838110015a2126.svg";